var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlaticonLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "103px",
    viewBox: "0 0 120 103",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loader-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "#FF00F0",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loader-logo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.372,56.137 L60.889,56.137 L72.045,37.6 L37.186,37.6 L25.688,18.539 L83.513,18.539 L94.668,0 L9.271,0 C5.925,0 2.842,1.801 1.198,4.716 C-0.446,7.623 -0.395,11.198 1.332,14.059 L51.712,97.56 C53.39,100.341 56.401,102.036 59.65,102.036 C62.896,102.036 65.907,100.341 67.585,97.56 L70.483,92.756 L48.372,56.137 Z",
    id: "Shape",
    fill: "#FF00F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(64.000000, 0.000000)",
    fill: "#69E781"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.575,18.539 L29.606,18.539 L29.606,18.543 L51.258,18.547 L53.963,14.059 C55.69,11.198 55.741,7.623 54.096,4.716 C52.454,1.801 49.371,4.4408921e-15 46.026,4.4408921e-15 L40.732,4.4408921e-15 L29.575,18.539 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "24.291 27.356 0.725 66.486 11.519 84.404 45.942 27.356"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaticonLogo);
export default __webpack_public_path__ + "static/media/flaticon-logo.885180da15c02546979ed58556e5b244.svg";
export { ForwardRef as ReactComponent };